import { Directive, OnInit, Input, Inject, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { UBXField, UBXFieldTypeEnum, UBXInputTypeEnum } from '../../../models';
import { UBXFieldBlockComponent } from '../block/field-block.component';

@Directive({
    selector: '[ubxFieldBox]',
})
export class UBXFieldBoxDirective implements OnInit {
    @Input('ubxFieldBox') field: UBXField;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        @Inject(UBXFieldBlockComponent) public block: UBXFieldBlockComponent,
    ) {}

    ngOnInit() {
        this.setAttrs(this.field);
    }

    setAttrs(field: UBXField) {
        // this.setClassType(field);

        const attrs = ['placeholder', 'maxLength', 'step'];
        attrs.forEach((attr) => {
            this.assignAttr(attr, field[attr]);
        });
    }

    private setClassType(field: UBXField) {
        const setClass = (type: string) => this.appendClass(`field__inputbox ${type}`);
        const setType = (type: string) => this.assignAttr('type', type);
        const customTypes = [UBXInputTypeEnum.AlphaNumeric, UBXInputTypeEnum.Iban];

        if (field.type === UBXFieldTypeEnum.Input) {
            if (customTypes.indexOf(field.input?.type) !== -1) {
                setClass(UBXInputTypeEnum.Text);
                setType(UBXInputTypeEnum.Text);
            } else {
                setClass(field.input ? field.input?.type : UBXInputTypeEnum.Text);
                if (field.input?.type !== UBXInputTypeEnum.Password) {
                    setType(field.input?.type);
                }
            }
        } else {
            setClass(field.type);
        }
    }

    private assignAttr(name: string, attr: string) {
        return attr && this.setAttr(name, attr);
    }

    private appendClass(names: string) {
        this.renderer.addClass(this.el.nativeElement, names);
    }

    private setAttr(name: string, value: string) {
        this.renderer.setAttribute(this.el.nativeElement, name, value);
    }

    @HostListener('focusin') focusIn() {
        this.block.focus = true;
    }
    @HostListener('focusout') focusOut() {
        this.block.focus = false;
        if (this.el.nativeElement.tagName === 'DIV') {
            this.block.value = this.el.nativeElement.innerText !== undefined ? true : false;
        } else {
            this.block.value = this.el.nativeElement.value ? true : false;
        }
    }
}
